<template src="./AppFooter.html"></template>
<style lang="scss" src="./AppFooter.scss"></style>

<script>
import {
    SfFooter,
    SfList,
    SfImage

} from '@storefront-ui/vue';
import {OrkSocial, OrkReassurance} from "@/components/Ork";
//import {OrkNewsletter} from "@/components/Ork";
import {icons} from "@/utils/icons";

export default {
    components: {
        SfImage,
        SfFooter,
        SfList,
        OrkSocial,
        OrkReassurance,
        //  OrkNewsletter,
    },

    data() {
        return {
            loading: true,
            isHome: '',
            footerColumns: [
                {
                    title: "About us",
                    items: ["Who we are", "Quality in the details", "Customer Reviews"],
                },
                {
                    title: "Departments",
                    items: ["Women fashion", "Men fashion", "Kidswear", "Home"],
                },
                {
                    title: "Help",
                    items: ["Customer service", "Size guide", "Contact us"],
                },
                {
                    title: "Payment & delivery",
                    items: ["Purchase terms", "Guarantee"],
                },
            ],
            social: [
                {
                    label: 'facebook',
                    link: 'http://www.facebook.com/pages/Air-France/10150136746870526?ref=ts',
                    icon: icons.facebook
                },
                {
                    label: 'instagram',
                    link: 'http://instagram.com/airfrance',
                    icon: icons.instagram
                },

                {
                    label: 'pinterest',
                    link: 'https://www.pinterest.fr/airfrance/',
                    icon: icons.pinterest
                },
                {
                    label: 'twitter',
                    link: 'menuFooter.link.twitter',
                    icon: icons.twitter
                },
                {
                    label: 'linkedIn',
                    link: 'http://www.linkedin.com/company/air-france',
                    icon: icons.linkedIn
                },

                {
                    label: 'youtube',
                    link: 'https://www.youtube.com/airfranceonair',
                    icon: icons.youtube
                },
            ],

            menuFooter1: [
                {
                    title: 'Q&A',
                    slug: '/faq',
                    target: '_self'
                },
                {
                    title: 'Delivery',
                    slug: '/livraison',
                    target: '_self'
                },
                {
                    title: 'Exchange / Return',
                    slug: '/echange-retour',
                    target: '_self'
                },
                {
                    title: 'Contact us',
                    slug: '/contact',
                    target: '_self'
                },
                {
                    title: 'Cookies consent',
                    slug: '/gestion-des-cookies',
                    target: '_self'
                }
            ],
            menuFooter2: [
                {
                    title: 'Book a flight',
                    slug: 'menuFooter.link.af',
                    target: '_blank'
                },
                {
                    title: 'Flying Blue Program',
                    slug: 'menuFooter.link.flyingBlue',
                    target: '_blank'
                },
                {
                    title: 'Terms of sales',
                    slug: '/conditions-generales-de-vente',
                    target: '_self'
                },
                {
                    title: 'Legal mentions',
                    slug: '/mentions-legales',
                    target: '_self'
                },
                {
                    title: 'Privacy policy',
                    slug: '/politique-de-protection-des-donnees-personnelles',
                    target: '_self'
                }
            ],
            menuFooter3: [
                {
                    title: 'Become a retailer',
                    slug: 'menuFooter.link.becomeRetailer',
                    target: '_blank'
                },
                {
                    title: 'Retailer acces',
                    slug: 'menuFooter.link.accesRetailer',
                    type: 'button',
                    target: '_blank'
                },

            ],
        };
    },
    created() {
        this.isHomeFn()
    },
    watch: {
        $route: 'isHomeFn'
    },
    methods: {
        isHomeFn() {
            this.isHome = this.$router.history.current.name
        }
    }
};
</script>

